// Copyright (c) 2017 Deere & Company

import '../index.scss';
import React, {PropTypes} from 'react';
import UpdateLayoutModalBody from './update-layout-modal-body';
import UpdateLayoutModalFooter from './update-layout-modal-footer';
import UpdateLayoutModalHeader from '../report-variant-modal-header';
import {WarrantyMediumModal} from '../../../../../shared/components/modal';

function handleCheckboxChange(selected) {

    this.actions.updateExistingLayout('isDefault', this.selectedLayout.name, selected);

}

function handleModalClose() {

    this.actions.updateLayoutModal(false);

}

function handleDelete() {

    this.actions.deleteLayout(this.reportName, this.selectedLayout.name);

}

function handleSave() {

    const columnState = btoa(JSON.stringify(this.columnApi.getColumnState()));
    const filterModel = btoa(JSON.stringify(this.gridApi.getFilterModel()));
    const sortModel = btoa(JSON.stringify(this.gridApi.getSortModel()));

    this.actions.saveReportLayout({
        columnState,
        filterModel,
        isDefault: this.selectedLayout.isDefault,
        name: this.selectedLayout.name,
        reportName: this.selectedLayout.reportName,
        sortModel
    });

}

const UpdateLayoutModal = props =>
    <WarrantyMediumModal
        className='create-layout-modal'
        isOpen={props.isOpen}
    >
        <UpdateLayoutModalHeader
            headerText='UPDATE_LAYOUT'
            onCloseButtonClick={props::handleModalClose}
        />
        <UpdateLayoutModalBody
            isSelected={props.selectedLayout ? props.selectedLayout.isDefault : false}
            layoutName={props.selectedLayout ? props.selectedLayout.name : ''}
            onCheckboxChange={props::handleCheckboxChange}
        />
        <UpdateLayoutModalFooter
            onCancel={props::handleModalClose}
            onDelete={props::handleDelete}
            onSave={props::handleSave}
        />
    </WarrantyMediumModal>;

UpdateLayoutModal.displayName = 'UpdateLayoutModal';
UpdateLayoutModal.propTypes = {
    actions: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    reportName: PropTypes.string.isRequired,
    selectedLayout: PropTypes.object
};

export default UpdateLayoutModal;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/update-layout-modal/update-layout-modal.js